import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { spencerConfig } from "./data";

export default function SpencerPage() {
  return <CityPageTemplate config={spencerConfig} />;
}